import { get, reduce } from 'lodash';
import { storageStackedUnitBuckets } from 'config/units';

// Helper to compute lowestPrice from units
function getLowestPriceFromUnits(units, unitsById) {
	if (!units) return null;
	const allUnitIds = [
		...(units.storageUnits || []),
		...(units.vehicleUnits || []),
	];
	const prices = allUnitIds
		.map(
			(id) =>
				unitsById &&
				unitsById[id] &&
				unitsById[id].price &&
				unitsById[id].price.meta,
		)
		.filter((price) => typeof price === 'number');
	return prices.length ? Math.min(...prices) : null;
}

// Selector to normalize the main facility object
export const getNormalizedFacility = (facility, unitsById) => {
	if (!facility) return facility;
	const facilityUnits = get(facility, 'units', {});
	const unitBuckets = reduce(
		storageStackedUnitBuckets,
		(allUnits, size) => ({
			...allUnits,
			[size]: unitsById && unitsById[facilityUnits[size]],
		}),
		{},
	);
	// Always return lowestPrice as a string (to match nearby facilities)
	let computedLowestPrice =
		facility.lowestPrice ||
		getLowestPriceFromUnits(facility.units, unitsById);
	if (computedLowestPrice !== undefined && computedLowestPrice !== null) {
		computedLowestPrice = computedLowestPrice.toString();
	} else {
		computedLowestPrice = '';
	}
	return {
		...facility,
		units: {
			...facilityUnits,
			...unitBuckets,
		},
		location: facility.location, // pass through or fallback if needed
		lowestPrice: computedLowestPrice,
	};
};
import { createSelector } from 'reselect';
// import formatFacility from '../../utils/store/formatFacility';

export const getNearbyFacilities = createSelector(
	(state) =>
		state.pages?.content?.nearbyFacilities ||
		state.app?.nearbyFacilities ||
		{},
	(nearbyFacilities) => {
		if (
			!nearbyFacilities.facilityCollection ||
			!nearbyFacilities.facilityCollection.collection
		) {
			return null;
		}
		const formatedNearbyFacilities =
			nearbyFacilities?.facilityCollection?.collection.map((facility) =>
				facility?.collection ? facility.collection : facility,
			);
		nearbyFacilities.facilityCollection.collection =
			formatedNearbyFacilities || [];

		return nearbyFacilities;
	},
);

export const getNearbyCities = createSelector(
	// Check both pages.content (for backward compatibility) and app state (for global availability)
	(state) =>
		state.pages?.content?.nearbyCities || state.app?.nearbyCities || [],
	(nearbyCities) => {
		return nearbyCities || [];
	},
);
